// extracted by mini-css-extract-plugin
module.exports = {"legendWrapper":"styles_legendWrapper__1sTjU","chartLegend":"styles_chartLegend__2DQta"};